import { render, staticRenderFns } from "./MarginRight.vue?vue&type=template&id=d400bd18&scoped=true&"
import script from "./MarginRight.vue?vue&type=script&lang=js&"
export * from "./MarginRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d400bd18",
  null
  
)

export default component.exports